export const harmonomicsBlue = "#092542";
